import { Controller } from "@hotwired/stimulus"

// Handles date picker navigation - submits form on date change
export default class extends Controller {
  static targets = ["input"]

  navigate() {
    this.element.requestSubmit()
  }
}
